module.exports = __webpack_public_path__ + "media/images/icons/in-blue-color-118819e8977930c05a51ce68ed86bb32.svg";